import React, { Fragment } from 'react'
import PaginatedConnectionTable from 'components/PaginatedConnectionTable'
import graphqlQuery from 'graphs/queries/ServersPaginated.graphql'
import withConnectionQuery from 'components/withConnectionQuery'
import fields from 'fields/servers'

const RouteServers = props => (
  <Fragment>
    <h3>Servers</h3>
    <PaginatedConnectionTable {...props} fields={fields} showNew />
  </Fragment>
)

export default withConnectionQuery({
  graphqlQuery,
  paginated: true,
  namespace: 'servers'
})(RouteServers)



// WEBPACK FOOTER //
// ./src/routes/admin/servers/index.js